import { MixAndMatchBaseCoupon } from "./mix-and-match-base";
export class MixAndMatchPercentageCoupon extends MixAndMatchBaseCoupon {
    computeDiscountAmount(items) {
        let discountAmount = 0;
        for (const item of items) {
            if (item.oPrice > 0) {
                discountAmount += (item.oPrice * this.discountValue / 100) - item.addOn;
            }
        }
        return discountAmount;
    }
    getConfiguredDiscountValueForDistribution() {
        // CouponBase ignores this for this couponTypeId.
        // Returning 0 avoids implying this value is a "price threshold".
        return 0;
    }
}
//# sourceMappingURL=mix-and-match-percentage.js.map